module.exports = __webpack_public_path__ + "media/yolo-3.0/Courses-94e2e6f5.svg";